import { GraphPayload, GraphQueryInput, createQuery } from '@ta/server';

import { Notification } from './dto/notification';

export function notifications(input: GraphQueryInput<Notification>): GraphPayload {
  return createQuery<Notification>('notifications', { ...input, prefixType: 'Notification' });
}

export function unreadNotificationCount(): GraphPayload {
  return createQuery<Notification>('unreadNotificationCount');
}
